import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import VSNImage from "../shared/VSNImage";

export const sortyByStatus = {
  name: "sortyByStatus",
  label: "Members Status",
  placeHolder: "Members status",
  IconComponent: () => <KeyboardArrowDownRoundedIcon />,
  options: [
    { key: "Invited", value: "invited" },
    { key: "Joined", value: "joined" },
    { key: "Assessment taken", value: "assessment_completed" },
  ],
  value: 0,
};
export const sortByRole = {
  name: "sortByRole",
  label: "Role",
  placeHolder: "Role",
  IconComponent: () => <KeyboardArrowDownRoundedIcon />,
  options: [
    { key: "User", value: "user" },
    { key: "Admin", value: "admin" },
  ],
  value: 0,
};
export const sortByVasanaType = {
  name: "sortByVasanaType",
  placeHolder: "Vasana type",
  label: "Vasana Type",
  IconComponent: () => <KeyboardArrowDownRoundedIcon />,
  options: [
    {
      key: (
        <VSNImage
          src={`${process.env.REACT_APP_MEDIA_URL}sa/colored-logo.svg`}
          alt="Sa"
        />
      ),
      value: "Sa",
    },
    {
      key: (
        <VSNImage
          src={`${process.env.REACT_APP_MEDIA_URL}re/colored-logo.svg`}
          alt="Re"
        />
      ),
      value: "Re",
    },
    {
      key: (
        <VSNImage
          src={`${process.env.REACT_APP_MEDIA_URL}ga/colored-logo.svg`}
          alt="Ga"
        />
      ),
      value: "Ga",
    },
    {
      key: (
        <VSNImage
          src={`${process.env.REACT_APP_MEDIA_URL}ma/colored-logo.svg`}
          alt="Ma"
        />
      ),
      value: "Ma",
    },
  ],
  value: 0,
};

export const defaultOptions = [{ key: "All", value: "" }];

export const pagination = {
  variant: "outlined",
  shape: "rounded",
};
